import React from "react";
import MetricChart from "@components/ui/charts/MetricChart";

const chartLabels = {
  steps: { actual: "Actual Steps", goal: "Steps Goal" },
  calories: { actual: "Calories Burnt", goal: "Calories Burnt Goal" },
  activeMinutes: { actual: "Active Time", goal: "Active Time Goal" },
};

const ChartSection = ({
  activeChartTab,
  setActiveChartTab,
  chartData,
  isMobile,
  goals,
}) => {
  return (
    <div className="bg-white rounded-2xl p-6">
      <div className="flex items-center justify-center gap-5">
        <div className="flex items-center justify-center gap-1">
          <div className="bg-[#05CFE6] w-4 h-4 rounded-full"></div>
          <h2 className="text-[12px] font-[600] font-[Lato] text-[#444444]">
            {chartLabels[activeChartTab]?.actual}
          </h2>
        </div>

        <div className="flex items-center justify-center gap-1 my-2">
          <div className="bg-[#FF8B38] w-4 h-4 rounded-full"></div>
          <h2 className="text-[12px] font-[600] font-[Lato] text-[#444444]">
            {chartLabels[activeChartTab]?.goal}
          </h2>
        </div>
      </div>

      {/* Chart Tabs */}
      <div className="flex flex-col md:flex-row bg-white rounded-full p-1 md:border md:border-[#E9E9E9] w-full gap-1 mt-1 mb-3">
        {["steps", "calories", "activeMinutes"].map((tab) => (
          <button
            key={tab}
            className={`${
              activeChartTab === tab
                ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
                : "text-gray-600 hover:bg-gray-100"
            } px-4 py-2 rounded-full text-[10px] md:text-[12px] font-medium flex-1 border border-[#E9E9E9] md:border-none capitalize`}
            onClick={() => setActiveChartTab(tab)}
          >
            {tab === "activeMinutes" ? "Active Time" : tab}
          </button>
        ))}
      </div>

      {/* Chart */}
      {chartData[activeChartTab]?.length > 0 ? (
        <MetricChart
          data={chartData}
          activeTab={activeChartTab}
          isMobile={isMobile}
          advisedActiveTime={goals?.goal_active_minutes}
          advisedCaloriesBurnt={goals?.goal_calories}
          advisedSteps={goals?.step_goal}
        />
      ) : (
        <div className="flex items-center justify-center h-[300px]">
          <p className="text-gray-500">
            No chart data available for this week
          </p>
        </div>
      )}
    </div>
  );
};

export default ChartSection;